import {AddressVerification} from "./AddressVerification";

export class Address {
    id?: bigint;
    streetAddress?: string;
    streetSubAddress?: string;
    city?: string;
    state?: string;
    country?: string;
    zipCode?: number;
    rawAddress?: string;
    verification?: AddressVerification = {
        valid: false,
        message: 'Address has not been verified yet'
    };
}

